import { Calendar, Filter, X } from 'lucide-react';
import React from 'react'
import { months } from '../../../../variables/datesFunctions';

const FiltersModal = ({ setShowFilters, styles, hasActiveFilters, selectedYear, selectedMonths, setSelectedYear, applyFilters, setSelectedMonths }) => {
    const currentYear = new Date().getFullYear();
    const startYear = 2009;
    const ct = currentYear - startYear + 1; // Calculate the total number of years needed

    const years = Array.from({ length: ct }, (_, i) => startYear + i).reverse();

    const toggleMonth = (month) => {
        setSelectedMonths(prev =>
            prev.includes(month)
                ? prev.filter(m => m !== month)
                : [...prev, month]
        );
    };

    const clearFilters = () => {
        setSelectedYear(new Date().getFullYear());
        setSelectedMonths([]);
    };

    return (
        <>
            {/* Overlay */}
            <div
                onClick={() => setShowFilters(false)}
                style={styles.filtersOverlay}
            />

            {/* Modal */}
            <div style={styles.filtersModal}>
                {/* Header modal */}
                <div style={styles.filtersHeaderModal}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            padding: '8px',
                            backgroundColor: '#eff6ff',
                            borderRadius: '8px'
                        }}>
                            <Filter style={{ width: '20px', height: '20px', color: '#2563eb' }} />
                        </div>
                        <div>
                            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#111827', margin: 0 }}>
                                Filtrer les sinistres
                            </h3>
                            <p style={{ fontSize: '13px', color: '#6b7280', margin: 0 }}>
                                Sélectionnez la période souhaitée
                            </p>
                        </div>
                    </div>
                    <button
                        onClick={() => setShowFilters(false)}
                        style={styles.closeFiltersButton}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#e5e7eb'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#f3f4f6'}
                    >
                        <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                    </button>
                </div>

                {/* Body modal */}
                <div style={{ padding: '24px' }}>
                    {/* Sélection de l'année */}
                    <div style={{ marginBottom: '24px' }}>
                        <label style={styles.exerciceLabel}>
                            <Calendar style={{ width: '16px', height: '16px' }} />
                            Exercice (Année)
                        </label>
                        <select
                            value={selectedYear ?? 'all'}
                            onChange={(e) => {
                                const value = e.target.value;
                                setSelectedYear(value === 'all' ? null : Number(value));
                            }}
                            style={styles.yearsOptions}
                            onFocus={(e) => e.target.style.borderColor = '#2563eb'}
                            onBlur={(e) => e.target.style.borderColor = '#e5e7eb'}
                        >
                            <option value="all">Tous les exercices</option>
                            {years.map(year => (
                                <option key={year} value={year}>{year}</option>
                            ))}
                        </select>
                    </div>

                    {/* Sélection des mois */}
                    <div>
                        <label style={styles.monthsLabel}>
                            Mois (sélection multiple)
                        </label>
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(3, 1fr)',
                            gap: '10px'
                        }}>
                            {months.map(month => (
                                <button
                                    key={month.value}
                                    onClick={() => toggleMonth(month.value)}
                                    style={{ ...styles.monthsButton, backgroundColor: selectedMonths.includes(month.value) ? '#2563eb' : 'white', border: selectedMonths.includes(month.value) ? 'none' : '2px solid #e5e7eb', color: selectedMonths.includes(month.value) ? 'white' : '#374151', }}
                                    onMouseEnter={(e) => {
                                        if (!selectedMonths.includes(month.value)) {
                                            e.target.style.backgroundColor = '#f9fafb';
                                            e.target.style.borderColor = '#2563eb';
                                        }
                                    }}
                                    onMouseLeave={(e) => {
                                        if (!selectedMonths.includes(month.value)) {
                                            e.target.style.backgroundColor = 'white';
                                            e.target.style.borderColor = '#e5e7eb';
                                        }
                                    }}
                                >
                                    {month.label}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Récapitulatif */}
                    {hasActiveFilters && (
                        <div style={styles.activeFilters}>
                            <p style={styles.activeFiltersP}>
                                📊 Filtres actifs : {selectedYear ? `Année ${selectedYear}` : 'Tous les exercices'}
                                {selectedMonths.length > 0 && ` • ${selectedMonths.length} mois sélectionné(s)`}
                            </p>
                        </div>
                    )}
                </div>

                {/* Footer modal */}
                <div style={styles.modalFooter}>
                    <button
                        onClick={clearFilters}
                        style={styles.clearFiltersButton}
                        onMouseEnter={(e) => {
                            e.target.style.backgroundColor = '#f9fafb';
                            e.target.style.borderColor = '#d1d5db';
                        }}
                        onMouseLeave={(e) => {
                            e.target.style.backgroundColor = 'white';
                            e.target.style.borderColor = '#e5e7eb';
                        }}
                    >
                        Réinitialiser
                    </button>
                    <button
                        onClick={applyFilters}
                        style={styles.applyFiltersButton}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#1d4ed8'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#2563eb'}
                    >
                        Appliquer les filtres
                    </button>
                </div>
            </div>

            <style>{`
            @keyframes fadeIn {
              from { opacity: 0; }
              to { opacity: 1; }
            }
            @keyframes slideIn {
              from {
                opacity: 0;
                transform: translate(-50%, -48%) scale(0.96);
              }
              to {
                opacity: 1;
                transform: translate(-50%, -50%) scale(1);
              }
            }
          `}</style>
        </>
    )
}

export default FiltersModal